import { useNodeItemContext } from '@/features/drive/entities/node/node-item-context'
import { cn } from '@/utils/styles/cn'
import { AnimatePresence, motion } from 'framer-motion'
import { Star } from 'lucide-react'
import { useId } from 'react'

export const NodeFavoriteActionStar = ({
    hideWhenInactive = false,
    className,
}: {
    hideWhenInactive?: boolean
    className?: string
}) => {
    const componentId = useId()

    const { node } = useNodeItemContext()

    return (
        <AnimatePresence key={'node-favorite-star' + componentId + node.uuid + node.isUserFavorite} mode="popLayout">
            <motion.div
                initial={{ scale: 0 }}
                animate={{ scale: 1 }}
                exit={{ scale: 0 }}
                transition={{ duration: 0.1, type: 'spring', bounce: 0.01 }}
            >
                <Star
                    className={cn(
                        'h-4 w-4 stroke-1',
                        hideWhenInactive && !node.isUserFavorite && 'opacity-0',
                        node.isUserFavorite
                            ? 'stroke-yellow-500 fill-yellow-400'
                            : 'stroke-[#FFFFFF99] stroke-[2px] fill-none group-hover:opacity-100 transition-opacity',
                        className
                    )}
                />
            </motion.div>
        </AnimatePresence>
    )
}

NodeFavoriteActionStar.displayName = 'NodeFavoriteStar'
